const MAX_SIDE = 2560
const QUALITY = 0.9

const decode = async (file) => {
  if (typeof createImageBitmap === "function") {
    try {
      return await createImageBitmap(file, { imageOrientation: "from-image" })
    } catch (e) {
      // Fall through: an <img> also applies the EXIF orientation.
    }
  }
  const url = URL.createObjectURL(file)
  try {
    const img = new Image()
    img.src = url
    await img.decode()
    return img
  } finally {
    URL.revokeObjectURL(url)
  }
}

// Any file the browser cannot decode (HEIC on most desktops) is sent as it is.
export const shrinkPhoto = async (file) => {
  try {
    const image = await decode(file)
    const scale = Math.min(1, MAX_SIDE / Math.max(image.width, image.height))
    if (scale === 1 && file.type === "image/jpeg") return file
    const canvas = document.createElement("canvas")
    canvas.width = Math.round(image.width * scale)
    canvas.height = Math.round(image.height * scale)
    const ctx = canvas.getContext("2d")
    ctx.imageSmoothingQuality = "high"
    ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
    if (image.close) image.close()
    const blob = await new Promise((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", QUALITY)
    )
    if (!blob || (scale === 1 && blob.size >= file.size)) return file
    return new File([blob], file.name.replace(/\.[^.]*$/, "") + ".jpg", {
      type: "image/jpeg",
      lastModified: file.lastModified,
    })
  } catch (e) {
    return file
  }
}
